<template>
  <section class="row mt-3 justify-content-between">
    <div class="col-12 font-weight-bold mb-1 bg-gray">{{ technicalHeadline }}</div>
    <div class="col-12 col-md-6" v-for="(item, index) in items" :key="index" :class="index === 0 ? 'col-lg-3' : 'col-lg-2' ">
      <div class="row">
        <div class="col-8 col-md-6 col-lg-12 py-1 font-weight-bold" v-html="item.title" />
        <div class="col-4 col-md-6 col-lg-12 py-1" v-html="item.value" />
      </div>
    </div>
  </section>
</template>

<script>

import { getString, getSectionTitle } from '../../../language'

const getOutput = (productData, name) => {
  return productData.technicalValues &&
    productData.technicalValues[name]
    ? productData.technicalValues[name].output
    : ''
}

export default {
  name: 'StoCscResultItemTechnicalValues',
  props: {
    technicalValues: Object
  },
  data: function () {
    return {
      technicalHeadline: getString('result.technicalHeadline')
    }
  },
  computed: {
    items () {
      return [
        {
          title: getSectionTitle('impactSoundLevel'),
          value: getOutput(this, 'impactSoundLevel')
        },
        {
          title: getSectionTitle('soundReductionIndex'),
          value: getOutput(this, 'soundReductionIndex')
        },
        {
          title: getSectionTitle('heatTransferCoefficient'),
          value: getOutput(this, 'heatTransferCoefficient')
        },
        {
          title: getSectionTitle('fireResistance'),
          value: getOutput(this, 'fireResistance')
        },
        {
          title: getSectionTitle('massPerUnitArea'),
          value: getOutput(this, 'massPerUnitArea')
        }
      ]
    }
  }
}

</script>
